import { Directive, AfterViewInit, ElementRef, Input } from "@angular/core";

import { Observable, Subscription } from "rxjs/Rx";
// tslint:disable-next-line:no-submodule-imports
import "rxjs/add/observable/fromEvent";
import "rxjs/add/operator/pairwise";
import "rxjs/add/operator/map";
import "rxjs/add/operator/exhaustMap";
import "rxjs/add/operator/filter";
import "rxjs/add/operator/startWith";
import { debounceTime } from "rxjs/operators";

interface ScrollPosition {
  scrollHeight: number;
  scrollTop: number;
  clientHeight: number;
}

const DEFAULT_SCROLL_POSITION: ScrollPosition = {
  scrollHeight: 0,
  scrollTop: 0,
  clientHeight: 0,
};

/**
 * based on  https://codeburst.io/angular-2-simple-infinite-scroller-directive-with-rxjs-observables-a989b12d4fb1
 */
@Directive({
  selector: "[appInfiniteScroller]",
})
export class InfiniteScrollerDirective implements AfterViewInit {
  @Input()
  public scrollCallback;
  @Input()
  public immediateCallback;
  @Input()
  public scrollPercent = 95;
  private scrollEvent$;
  private userScrolledDown$;
  private requestOnScroll$;

  constructor(private elm: ElementRef) {}

  public ngAfterViewInit() {
    this.registerScrollEvent();

    this.streamScrollEvents();

    this.requestCallbackOnScroll();
  }

  private registerScrollEvent() {
    this.scrollEvent$ = Observable.fromEvent(this.elm.nativeElement, "scroll");
  }

  private streamScrollEvents() {
    this.userScrolledDown$ = this.scrollEvent$
      .map(
        (e: any): ScrollPosition => ({
          scrollHeight: e.target.scrollHeight,
          scrollTop: e.target.scrollTop,
          clientHeight: e.target.clientHeight,
        })
      )
      .pairwise()
      .filter(
        (positions) =>
          this.isUserScrollingDown(positions) &&
          this.isScrollExpectedPercent(positions[1])
      );
  }

  private requestCallbackOnScroll() {
    this.requestOnScroll$ = this.userScrolledDown$;

    if (this.immediateCallback) {
      this.requestOnScroll$ = this.requestOnScroll$.startWith([
        DEFAULT_SCROLL_POSITION,
        DEFAULT_SCROLL_POSITION,
      ]);
    }

    this.requestOnScroll$
      .pipe(debounceTime(300))
      .map(($event) => {
        return this.scrollCallback($event);
      })
      .subscribe(() => {});
  }

  private isUserScrollingDown = (positions) => {
    return positions[0].scrollTop < positions[1].scrollTop;
  };

  private isScrollExpectedPercent = (position) => {
    // if (position.scrollTop < 1) {
    //   return false;
    // }
    return (
      position.scrollTop + position.clientHeight / position.scrollHeight >
      this.scrollPercent / 100
    );
  };
}



// WEBPACK FOOTER //
// ./src/app/_directives/scroll-directive/infinite-scroll.directive.ts